import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import GeneralHelper from '../../modules/General.js';
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import General from '../../helpers/General.js';
import moment from 'moment';

class Push extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            unknownDiscounts:[],
            discounts:[],
        }

        this.rows = this.rows.bind(this);
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }


    rows() {
        let data = this.placeholderRow(10,5);

        this.state.data.notifications.map((notification,i) => {
            data[i] =
                <tr key={`notification-${notification.id}`}>
                    <td>{notification.id}</td>
                    <td>
                        {notification.title}
                    </td>
                    <td>
                        {notification.clicks}
                    </td>
                    <td>
                        {notification.received}
                    </td>
                    <td>
                        {notification.sent == '1' ? moment(General.toLocalTime(notification.created_at)).fromNow():'Processing'}
                    </td>

                </tr>

        })

        return data;
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }


    componentWillMount() {

        axios.get(`/push?include=subscribers`)
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'data':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-rocket"></i> Push notifications</span>
                    <div className="page-header-actions">
                        <Link to={GeneralHelper.Link("/push/new")} className="btn btn-dark"><i className="icon fa-plus" style={{marginRight:'10px'}}></i>  New</Link>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Push notifications | Crall.io" />

                    {
                        this.props.general.settings.PUSH_ACTIVE != '1' ?
                            <div className="row">
                                <div className="col-sm-4 offset-sm-3">
                                    <div className="alert alert-icon alert-danger alert-dismissible" role="alert">
                                        <i className="icon wb-bell" aria-hidden="true"></i> Push notifications is not enabled.
                                        <p className="m-t-15">
                                            <Link to={GeneralHelper.Link("/settings/push")} className="btn btn-danger">Configure push notifications</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>:null
                    }

                    <OptionColumn title="Notifications" panel={false} description={<span>Overview of sent notifications.<br /><span className="tag tag-default">You have <strong>{this.state.data.subscribers}</strong> subscribers</span><div className="alert dark alert-info" role="alert">INFO : This feature is only supported in Chrome / Firefox on PC and newer android devices.</div></span>}>
                        <table className="table outline">
                            <thead>
                            <tr>
                                <th>
                                    Id
                                </th>
                                <th>
                                    Title
                                </th>
                                <th>
                                    Clicks
                                </th>
                                <th>
                                    Received
                                </th>
                                <th>
                                    Sent at
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.rows()
                            }
                            </tbody>
                        </table>
                    </OptionColumn>

                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Push = connect(mapStateToProps,mapDispatchToProps)(Push);
export default Push;


// WEBPACK FOOTER //
// ./containers/push/Push.js